import cn from "classnames";
import styles from "../styles.module.scss";
import {useEffect, useState} from "react";
import Image from "next/image";
import {toBase64} from "../../../../../helpers/toBase64";

export const shimmer = (w, h) => `
<svg width="${w}" height="${h}" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
  <defs>
    <linearGradient id="g">
      <stop stop-color="#fff" offset="20%" />
      <stop stop-color="#fff" offset="50%" />
      <stop stop-color="#fff" offset="70%" />
    </linearGradient>
  </defs>
  <rect width="${w}" height="${h}" fill="#EFF2F9" />
  <rect id="r" width="${w}" height="${h}" fill="url(#g)" />
  <animate xlink:href="#r" attributeName="x" from="-${w}" to="${w}" dur="1s" repeatCount="indefinite"  />
</svg>`

const FeatureImg = ({img}) => {
  const [isMount, setIsMount] = useState(false);

  useEffect(() => {
    setIsMount(true);
  }, [])

  return (
    <div className={cn(styles["features__img-wrapper"], {[styles["img--animate"]]: isMount})}>
      <div>
        <Image src={img} quality={100}  alt="DevIT.SoftWare" placeholder="blur" blurDataURL={`data:image/svg+xml;base64,${toBase64(shimmer(700, 475))}`}/>
      </div>
    </div>
  );
};

export default FeatureImg;